export function layoutSessionRenameFailedMessage() {
  return "Session title could not be saved. Try a shorter title or try again."
}

export function layoutStarterProjectCreateFailedMessage(path: string) {
  return `We couldn't create the starter project in ${path}. Change the project location or try again.`
}

export function layoutStarterProjectUnsupportedTemplateMessage() {
  return "This starter template needs a newer OpenAnalyst desktop build. Restart OpenAnalyst or update the app, then try again."
}

export function layoutHostedFolderPickerFailedMessage() {
  return "We couldn't open that folder. Choose another folder or try again."
}

export function layoutHostedProjectUploadFailedMessage() {
  return "We couldn't upload this project. Check the folder contents and try again."
}

export function layoutWorkspaceDeleteFailedMessage() {
  return "Workspace could not be deleted. Close any running sessions and try again."
}

export function layoutWorkspaceResetFailedMessage() {
  return "Workspace could not be reset. Close any running sessions and try again."
}

export function layoutOpenDirectoryFailedMessage() {
  return "Folder could not be opened. Open it from your file manager or try again."
}

export function layoutProjectLabelSaveFailedMessage() {
  return "Project label could not be saved. Check project settings and try again."
}

export function layoutThreadLabelSaveFailedMessage() {
  return "Thread label could not be saved. Try again from the thread menu."
}

export function layoutWorkspaceCreateFailedMessage() {
  return "Workspace could not be created. Check the project folder and try again."
}

export function layoutWorkspaceGitInitFailedMessage() {
  return "Git could not be initialized for this project. Check that Git is installed and the folder is writable, then try again."
}
